import React, { PropTypes, Component } from 'react';

import {
  NitroHeading,
  NitroDivider,
  NitroTable,
  NitroFormatter,
  NitroIcon,
  NitroButtonGroup,
  NitroButton,
  NitroText,
} from 'nitro-components';

import SummaryHeading from './SummaryHeading.js';

import styled from 'styled-components';

import { media } from 'style-utils';

import DocumentAPI from '../../api/DocumentApi';

const SidepanelSection = styled.section`
  margin-bottom: 20px;
`;

const IndicatorSection = styled.section`
  padding-top: 5px;
  padding-bottom: 8px;
`;

const IndicatorContainer = styled.div`
  margin: auto;
  width: 100%;
  text-align: center;
  background-color: ${props => props.theme.color.white};
  border: 1px solid ${props => props.theme.color.border};
  padding: 12px;
  margin-bottom: 10px;
`;

const DeleteConfirmation = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  ${media.mobile`
     flex-direction: column;
     justify-content: center;
     align-items: center;
  `}
`;

const DeleteButtonGroup = styled.section`
  display: inline-block;
  margin-left: 40px;
  ${media.mobile`
    margin-left: 10px;
    margin-top: 5px;
  `}
`;

const DetailsContainer = styled.section`
  display: inline-block;
  text-align: right;
  cursor: pointer;
  padding-right: 10px;
`;

const Description = styled.section`
  border: 1px solid ${props => props.theme.color.border};
  border-radius: 2px;
  color: ${props => props.theme.color[props.colorCode]};
  padding: 15px;
  background: ${props => props.theme.color.white};
`;

const PreDescription = styled.pre`
  font-family: monospace;
  border: 1px solid ${props => props.theme.color.border};
  border-radius: 2px;
  padding: 15px;
  background: ${props => props.theme.color.white};
  white-space: pre-line;
`;

class GenericTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteNotificationIndex: -1,
      expandedRow: -1,
    };
    this.handleDelete = this.handleDelete.bind(this);
    this.toggleDeleteConfirmation = this.toggleDeleteConfirmation.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.expandRow = this.expandRow.bind(this);
  }

  handleDelete = (e, index, row) => {
    e.stopPropagation();
    this.setState({
      deleteNotificationIndex: index,
      deleteObject: row.Action,
    });
  };

  handleDownload = (e, index, row) => {
    e.stopPropagation();
    console.log('this handle dl', this, index, row);
    const { File, Download } = row;
    DocumentAPI.downloadWithUrl(Download, File);
  };

  deleteRow = () => {
    this.props.action(this.state.deleteObject, this.props.ActionDetails);
  };

  expandRow = (e, index) => {
    e.stopPropagation();
    let expandedRow = this.state.expandedRow;
    if (expandedRow != index) {
      this.setState({ expandedRow: index });
    } else {
      this.setState({ expandedRow: -1 });
    }
  };

  toggleDeleteConfirmation = () => {
    this.setState({
      deleteNotificationIndex: -1,
    });
  };

  renderDefaultCell = cell => {
    if (cell && typeof cell === 'object') {
      return (
        <span>
          {cell.Icon && (
            <NitroIcon name={cell.Icon} size={10} right={10} variant="base3" />
          )}
          {cell.Value ? cell.Value : cell}
        </span>
      );
    }

    return cell;
  };

  render() {
    const {
      category,
      headers,
      rows,
      footers,
      showHeader,
      HeaderPostFix,
      fromNotification,
      ActionDetails,
      IndicatorHeader,
      title,
    } = this.props;

    const { expandedRow } = this.state;
    let expandCollapseExist = false;
    const childrenExist = rows[0].Children && rows[0].Children.length > 0;
    let isTotalRow = false;

    const colorCode = fromNotification ? 'notification' : 'primary';
    const rowFormatter = ({ rows, rowClassName }) => {
      isTotalRow = rowClassName === 'table-totals';
      return rows.map((row, index) => {
        let tds = [];
        if (this.state.deleteNotificationIndex !== index) {
          tds = headers.map(($, idx) => {
            const columnName = $['@Name'];
            let tdValue = row[columnName];
            const isDefined = tdValue !== undefined;
            const HighlightedCellsClass =
              row.HighlightedCells && row.HighlightedCells.includes(columnName)
                ? 'table-data-highlight'
                : '';
            /**Check for notification cells - Can be obtained by clubbing  HighlightedCells with fromNotification flag -
            To be considered for removal when driverAlerts reports is done- Mythreyi**/
            const HightlightedNotificationCellsClass =
              row.HighlightedNotificationCells &&
              row.HighlightedNotificationCells.includes(columnName)
                ? row.HighlightType == 'alert'
                  ? 'table-data-hightlight-negative'
                  : 'table-data-hightlight-notification'
                : '';

            /**Added to indentify columns which are to be bolded**/
            const ColumnBold =
              row.BoldColumns && row.BoldColumns.includes(columnName)
                ? 'table-data-bold'
                : '';

            /**Custom styling - Adds a smaller font with base2 and size 12**/
            const VariantPrimitiveCells =
              row.VariantPrimitiveCells &&
              row.VariantPrimitiveCells.includes(columnName)
                ? 'table-data-primitive-cell'
                : '';
            // only show mouse pointer if row contains Children
            const noPointerCellsClass = row.Children
              ? ''
              : 'table-data-no-pointer';
            let alignment = '';
            /**Check for delete**/
            if ($['@ActionType'] === 'delete') {
              tdValue = (
                <span onClick={e => this.handleDelete(e, index, row)}>
                  {' '}
                  <NitroIcon
                    name="delete"
                    size="12"
                    right={6}
                    variant="base3"
                    hoverVariant="base2"
                  />
                </span>
              );
            }

            /**Check for download**/
            if ($['@ActionType'] === 'download') {
              tdValue = (
                <span
                  onClick={e => this.handleDownload(e, index, row)}
                  style={{ cursor: 'pointer' }}
                >
                  <i className="fas fa-file-download" />
                </span>
              );
            }

            /**Check for delete ends**/
            if ($['@DataType'] === 'Currency') {
              tdValue = <NitroFormatter data={tdValue} type="currency" />;
              alignment = 'align-right';
            } else {
              alignment = 'align-center';
            }
            /**Check for expand collapse component - used for details in notification driver drilldown**/
            if ($['@DisplayType'] === 'ExpandCollapse' && tdValue) {
              expandCollapseExist = true;
              tdValue = (
                <DetailsContainer>
                  <NitroText size={4} variant={this.props.Variant}>
                    {tdValue.Label}
                  </NitroText>
                  <NitroIcon
                    name={`accordion-${
                      this.state.expandedRow === index ? 'up' : 'down'
                    }`}
                    size={8}
                    left={6}
                  />
                </DetailsContainer>
              );
              alignment = 'align-right';
            }
            /**Check for expand collapse component ends**/

            /**Check for expand collapse component - used for details in notification driver drilldown**/
            if ($['@DisplayType'] === 'AttributeRow' && tdValue) {
              expandCollapseExist = true;
              tdValue = <DetailsContainer />;
              alignment = 'align-right';
            }
            /**Check for expand collapse component ends**/

            if (!$['@DisplayType']) {
              tdValue = (
                <NitroText
                  variant={this.props.Variant}
                  bold={row.BoldColumns && row.BoldColumns.includes(columnName)}
                >
                  {this.renderDefaultCell(tdValue)}
                </NitroText>
              );
            }
            let colspan = 1;
            if (row.Colspan && row.Colspan[columnName]) {
              colspan = row.Colspan[columnName];
            }

            //Return actions based on type of row
            return (
              isDefined && (
                <td
                  key={idx}
                  onClick={e =>
                    (row.Children &&
                      this.props.drillDown({
                        navTitle: category,
                        drillDownData: row.Children,
                      })) ||
                    (expandCollapseExist && this.expandRow(e, index))
                  }
                  colSpan={colspan}
                  className={`table-data ${noPointerCellsClass} ${HighlightedCellsClass} ${HightlightedNotificationCellsClass} ${VariantPrimitiveCells} ${ColumnBold} table-data-${alignment}`}
                >
                  {tdValue}
                </td>
              )
            );
          });
        }
        /**Component to be added if @ActionType delete is present in the table**/
        const deleteConfirmation =
          this.state.deleteNotificationIndex === index ? (
            <td colSpan={this.props.headers.length + 1}>
              <DeleteConfirmation>
                <NitroHeading
                  size="3"
                  variant="base2"
                  bold
                  noMargin
                  label={ActionDetails.ConfirmationLabel}
                />
                <DeleteButtonGroup>
                  <NitroButtonGroup layout="horizontal" inline>
                    <NitroButton
                      size="extraSmall"
                      label="Yes, delete"
                      variant={colorCode}
                      action={this.deleteRow}
                    />
                    <NitroButton
                      size="extraSmall"
                      label="Cancel"
                      action={this.toggleDeleteConfirmation}
                    />
                  </NitroButtonGroup>
                </DeleteButtonGroup>
              </DeleteConfirmation>
            </td>
          ) : null;
        /**Delete confirmation component ends**/

        const drillDownIcon = row.Indicator ? (
          <NitroIcon
            name={row.Indicator}
            size={21}
            top={10}
            variant={this.props.Variant}
            shadow
          />
        ) : (
          <NitroIcon
            name="arrow-right"
            size={8}
            right={12}
            variant={this.props.Variant}
          />
        );

        const drilldown =
          this.state.deleteNotificationIndex !== index && row.Children ? (
            <td
              className="table-data table-data-align-right"
              onClick={() =>
                row.Children &&
                this.props.drillDown({
                  navTitle: category,
                  drillDownData: row.Children,
                })
              }
            >
              {drillDownIcon}
            </td>
          ) : null;

        // Add empty column if footer exist and it is the total row
        const emptyColumn = childrenExist && isTotalRow ? <td /> : null;

        //Added check for delete items and expandCollapse component. Row colors where having issues when setting from css.So adding the class from JS. - Mythreyi
        // Do multiple check and add rows accordingly
        const rowItems = [];
        let rowBackground;
        if (index % 2 === 0) {
          rowBackground = 'even';
        } else {
          rowBackground = 'odd';
        }
        if (this.state.deleteNotificationIndex === index) {
          rowItems.push(
            <tr
              key={index}
              className={`${rowBackground} ${rowClassName} || "table-body-row"`}
            >
              {deleteConfirmation}
            </tr>
          );
        } else {
          rowItems.push(
            <tr
              key={index}
              className={`${rowBackground} ${rowClassName} || "table-body-row"`}
            >
              {tds}
              {drilldown}
              {emptyColumn}
            </tr>
          );
        }
        if (expandedRow === index) {
          rowItems.push(
            <tr
              className={`${rowBackground} noBorder ${rowClassName} || table-body-row`}
            >
              <td
                colSpan={this.props.headers.length + 1}
                className="no-padding-top"
              >
                {row.ExpandCollapse && (
                  <Description colorCode={colorCode}>
                    {' '}
                    {row.ExpandCollapse.Description}{' '}
                  </Description>
                )}
              </td>
            </tr>
          );
        }

        if (
          row.AttributeRow &&
          row.AttributeRow.Description &&
          row.AttributeRow.Description !== ''
        ) {
          rowItems.push(
            <tr
              className={`${rowBackground} noBorder ${rowClassName} || table-body-row`}
            >
              <td
                colSpan={this.props.headers.length + 1}
                className="no-padding-top"
              >
                <PreDescription>{row.AttributeRow.Description}</PreDescription>
              </td>
            </tr>
          );
        }
        //  multiple check ends - Returns the rows
        return rowItems;
      });
    };

    const columnHeaders = headers.map(($, idx) => {
      const alignment = $['@DataType'] === 'Currency' ? 'right' : 'center';
      return (
        <th key={idx} className={`table-header table-header-${alignment}`}>
          {$['@Display']}
        </th>
      );
    });

    const tableRows = rowFormatter({ rows });

    /**Temp sol to use highlighted in case of certain tables .. need to move whole thing to styled component - TODO **/
    const isHiglightedTable = title === 'Vehicle Utilisation Graph';

    const footersRows =
      footers && rowFormatter({ rows: footers, rowClassName: 'table-totals' });

    /**Add a empty th if drill down exist**/
    const tableHeader = showHeader ? (
      <thead>
        <tr className="table-head-row">
          {columnHeaders}
          {childrenExist && <th className="table-header" />}
        </tr>
      </thead>
    ) : null;

    // switch to differnt headerlayout for last drill down
    // last drill down table data contains HeaderPostFix

    const header = !HeaderPostFix ? (
      <section>
        <NitroHeading
          label={category}
          labelHighlight={HeaderPostFix}
          size="2"
          align="center"
          noMargin
          variant="secondary"
        />
        {typeof category != 'undefined' && category != '' && (
          <NitroDivider noTopPad sidePanel />
        )}
      </section>
    ) : (
      <section>
        {typeof category != 'undefined' && category != '' && (
          <NitroDivider noTopPad sidePanel />
        )}
        <SummaryHeading title={category} result={HeaderPostFix} />
      </section>
    );

    //get indicator section // TODO check with backend team to not send empty IndicatorHeader
    const indicator = IndicatorHeader && IndicatorHeader.text && (
      <IndicatorSection>
        <IndicatorContainer>
          <NitroIcon
            name={IndicatorHeader.Icon}
            size={23}
            right={12}
            top={10}
            variant={this.props.Variant}
            shadow
          />
          <NitroText>{IndicatorHeader.text}</NitroText>
        </IndicatorContainer>
      </IndicatorSection>
    );

    return (
      <SidepanelSection>
        {header}

        {indicator}

        {/**Temp sol to use highlighted in case of certain tables .. need to move whole thing to styled component - TODO **/}
        <NitroTable highlighted={isHiglightedTable} highlightAlignCenter>
          {tableHeader}
          <tbody>
            {tableRows}
            {footersRows}
          </tbody>
        </NitroTable>
      </SidepanelSection>
    );
  }
}

GenericTable.propTypes = {
  actions: PropTypes.object,
  navTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  headers: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  footers: PropTypes.array,
  drillDown: PropTypes.func.isRequired,
  handleBackClick: PropTypes.func.isRequired,
  showHeader: PropTypes.bool,
  HeaderPostFix: PropTypes.string,
  action: PropTypes.func,
  fromNotification: PropTypes.bool,
  ActionDetails: PropTypes.object,
  Variant: PropTypes.string,
  IndicatorHeader: PropTypes.object,
};

export default GenericTable;



// WEBPACK FOOTER //
// ./src/components/factoryComponents/GenericTable.js